const translations = {
  "en": {
    "%{count} accounts failed to sync. Please try again later.": "%{count} accounts failed to sync. Please try again later.",
    "5 moves get you there sooner": "5 moves get you there sooner",
    "A 90-second money scan": "A 90-second money scan",
    "A 90-second scan · 9 quick questions": "A 90-second scan · 9 quick questions",
    "A plan for your money": "A plan for your money",
    "Across %{var0}": "Across %{var0}",
    "Against roles like yours in the same line": "Against roles like yours in the same line",
    "Age, income, the basics — about a minute.": "Age, income, the basics — about a minute.",
    "AI already does": "AI already does",
    "AI coverage of your role": "AI coverage of your role",
    "Bring single-name concentration into your 15% guardrail, staged over 6 months.": "Bring single-name concentration into your 15% guardrail, staged over 6 months.",
    "Complete this plan": "Complete this plan",
    "Compounding your investments": "Compounding your investments",
    "Continue": "Continue",
    "Control": "Control",
    "Data sync issue": "Data sync issue",
    "Ed needs to see your holdings for this one — link, upload, or start somewhere else.": "Ed needs to see your holdings for this one — link, upload, or start somewhere else.",
    "financial fitness score": "financial fitness score",
    "Financial fitness score": "Financial fitness score",
    "Finding people on your path": "Finding people on your path",
    "Free for 7 days · cancel anytime": "Free for 7 days · cancel anytime",
    "From Ed": "From Ed",
    "Get my number": "Get my number",
    "Get my score": "Get my score",
    "Goal for you": "Goal for you",
    "Good to meet you, %{var0}. Just a little about you first.": "Good to meet you, %{var0}. Just a little about you first.",
    "Got it, %{var0}. Give me a moment to put your profile together.": "Got it, %{var0}. Give me a moment to put your profile together.",
    "Growth": "Growth",
    "Hmm — I hit a snag.": "Hmm — I hit a snag.",
    "How much of the day-to-day is already done with AI": "How much of the day-to-day is already done with AI",
    "I couldn't finish that one.": "I couldn't finish that one.",
    "I crunch the numbers while you wait.": "I crunch the numbers while you wait.",
    "I read your money in the background": "I read your money in the background",
    "I'll read": "I'll read",
    "I'll read your money": "I'll read your money",
    "I'm Ed — your money person.": "I'm Ed — your money person.",
    "in 90 seconds.": "in 90 seconds.",
    "Insights about": "Insights about",
    "Let's fix one thing first": "Let's fix one thing first",
    "Let's go": "Let's go",
    "Measured across everything the job involves day to day, task by task.": "Measured across everything the job involves day to day, task by task.",
    "Meet your": "Meet your",
    "Needs your investment account": "Needs your investment account",
    "Nothing stands out as broken — go back and adjust your answers, or keep chatting with Ed.": "Nothing stands out as broken — go back and adjust your answers, or keep chatting with Ed.",
    "One clear target, built around you.": "One clear target, built around you.",
    "One goal you can start today": "One goal you can start today",
    "One number for how your money's really doing.": "One number for how your money's really doing.",
    "Pick the one you want me to take on now. The rest stay on your list — we'll get to them together.": "Pick the one you want me to take on now. The rest stay on your list — we'll get to them together.",
    "Pinpointing your $1M year": "Pinpointing your $1M year",
    "Reading your income & savings": "Reading your income & savings",
    "Reading your money": "Reading your money",
    "Roles closest to yours in %{var0}": "Roles closest to yours in %{var0}",
    "Safety": "Safety",
    "Same job, new way of doing it.": "Same job, new way of doing it.",
    "See how much of your work": "See how much of your work",
    "See where you're headed": "See where you're headed",
    "Show all %{var0} roles": "Show all %{var0} roles",
    "Show fewer": "Show fewer",
    "Some account data didn't finish syncing. Please try again in a little while — refresh to restart.": "Some account data didn't finish syncing. Please try again in a little while — refresh to restart.",
    "Start here — the biggest gain for you": "Start here — the biggest gain for you",
    "Syncing your account data…": "Syncing your account data…",
    "Syncing your accounts (%{synced}/%{total})": "Syncing your accounts (%{synced}/%{total})",
    "Tasks already done with AI": "Tasks already done with AI",
    "The shift in your line of work has already started.": "The shift in your line of work has already started.",
    "Then a money plan sized to your numbers.": "Then a money plan sized to your numbers.",
    "This much is already being done with AI by people in your role.": "This much is already being done with AI by people in your role.",
    "Try again": "Try again",
    "Unlock my full plan": "Unlock my full plan",
    "What this means": "What this means",
    "What this plan does for your score": "What this plan does for your score",
    "What's in your score": "What's in your score",
    "Where you sit": "Where you sit",
    "You": "You",
    "You answer a few quick questions": "You answer a few quick questions",
    "You get a goal worth chasing": "You get a goal worth chasing",
    "You get your Fitness Score": "You get your Fitness Score",
    "Your answers are safe — nothing's lost.": "Your answers are safe — nothing's lost.",
    "Your answers are saved, so this is just one more tap.": "Your answers are saved, so this is just one more tap.",
    "Your cushion if a shock hits": "Your cushion if a shock hits",
    "Your Financial fitness score": "Your Financial fitness score",
    "Your line": "Your line",
    "your money": "your money",
    "Your money": "Your money",
    "Your money building": "Your money building",
    "Your monthly cash flow": "Your monthly cash flow",
    "Your Plan": "Your Plan",
    "Your role": "Your role",
    "Your starting number — and a goal to lift it.": "Your starting number — and a goal to lift it."
  },
  "zh-tw": {
    "%{count} accounts failed to sync. Please try again later.": "%{count} 個帳戶同步失敗。請稍後再試。",
    "5 moves get you there sooner": "5 項操作助你更快達標",
    "A 90-second money scan": "90 秒資金掃描",
    "A 90-second scan · 9 quick questions": "90秒快速評估 · 9道簡短問題",
    "A plan for your money": "你的理財計畫",
    "Across %{var0}": "%{var0} 全部職位",
    "Against roles like yours in the same line": "和同一行裡跟你相近的職位比",
    "Age, income, the basics — about a minute.": "年齡、收入等基本資料，約需一分鐘。",
    "AI already does": "有多少 AI 已經在做",
    "AI coverage of your role": "AI 在你職位上的涵蓋率",
    "Bring single-name concentration into your 15% guardrail, staged over 6 months.": "將個股集中度調整至你的 15% 控管區間內，並分階段於 6 個月內完成。",
    "Complete this plan": "完成此計畫",
    "Compounding your investments": "投資複利成長",
    "Continue": "繼續",
    "Control": "掌控力",
    "Data sync issue": "資料同步問題",
    "Ed needs to see your holdings for this one — link, upload, or start somewhere else.": "Ed 需要查看你的持倉才能繼續 — 請連結、上傳，或從其他處開始。",
    "financial fitness score": "財務健康分數",
    "Financial fitness score": "財務健康分數",
    "Finding people on your path": "尋找與你同行的投資人",
    "Free for 7 days · cancel anytime": "7 天免費體驗 · 隨時取消",
    "From Ed": "來自 Ed",
    "Get my number": "看看我的數字",
    "Get my score": "取得我的評分",
    "Goal for you": "你的目標",
    "Good to meet you, %{var0}. Just a little about you first.": "很高興認識你，%{var0}。先簡單了解你的情況。",
    "Got it, %{var0}. Give me a moment to put your profile together.": "收到，%{var0}。請稍候，我正在為你建立投資檔案。",
    "Growth": "成長",
    "Hmm — I hit a snag.": "嗯——目前遇到些狀況。",
    "How much of the day-to-day is already done with AI": "日常工作有多少已經由 AI 在做",
    "I couldn't finish that one.": "我沒能完成那一項。",
    "I crunch the numbers while you wait.": "你等待期間，我會把數字都算好。",
    "I read your money in the background": "我會在背景持續讀你的錢",
    "I'll read": "正在讀取",
    "I'll read your money": "我來讀你的錢",
    "I'm Ed — your money person.": "我是 Ed — 你的私人理財官。",
    "in 90 seconds.": "在 90 秒內。",
    "Insights about": "關於的洞察",
    "Let's fix one thing first": "先解決一項問題",
    "Let's go": "開始",
    "Measured across everything the job involves day to day, task by task.": "就該工作日常涉及的一切事項，逐項予以衡量。",
    "Meet your": "認識你的",
    "Needs your investment account": "需要你的投資帳戶",
    "Nothing stands out as broken — go back and adjust your answers, or keep chatting with Ed.": "目前未偵測到異常 — 返回並調整你的回答，或繼續與 Ed 對話。",
    "One clear target, built around you.": "一個明確目標，為你量身打造。",
    "One goal you can start today": "一個今天就能開始的目標",
    "One number for how your money's really doing.": "一個數字，掌握你的資金實際表現。",
    "Pick the one you want me to take on now. The rest stay on your list — we'll get to them together.": "選擇你希望我現在處理的項目。其餘將保留在你的清單中，後續再與你一同推進。",
    "Pinpointing your $1M year": "精準推算你的百萬目標年",
    "Reading your income & savings": "正在讀取你的收入與儲蓄",
    "Reading your money": "正在分析你的資產",
    "Roles closest to yours in %{var0}": "%{var0} 中和你最接近的職位",
    "Safety": "安全性",
    "Same job, new way of doing it.": "同樣的工作，全新的做法。",
    "See how much of your work": "看看你的工作",
    "See where you're headed": "查看你的目標進度",
    "Show all %{var0} roles": "顯示全部 %{var0} 個職位",
    "Show fewer": "收合",
    "Some account data didn't finish syncing. Please try again in a little while — refresh to restart.": "部分帳戶資料尚未同步完成。請稍後再試 — 重新整理以重啟。",
    "Start here — the biggest gain for you": "從這裡開始 — 為你帶來最大收益",
    "Syncing your account data…": "正在同步你的帳戶資料…",
    "Syncing your accounts (%{synced}/%{total})": "正在同步您的帳戶 (%{synced}/%{total})",
    "Tasks already done with AI": "AI 已經在做的事",
    "The shift in your line of work has already started.": "你所從事領域的轉變已經開始。",
    "Then a money plan sized to your numbers.": "接著，照你的數字給一份理財計畫。",
    "This much is already being done with AI by people in your role.": "和你同職位的人，已經有這麼多工作是用 AI 在做了。",
    "Try again": "重試",
    "Unlock my full plan": "解鎖我的完整計畫",
    "What this means": "這代表什麼",
    "What this plan does for your score": "此計畫如何影響你的評分",
    "What's in your score": "你的評分由哪些項目組成",
    "Where you sit": "你的位置",
    "You": "你",
    "You answer a few quick questions": "回答幾個快速問題",
    "You get a goal worth chasing": "擁有值得追求的目標",
    "You get your Fitness Score": "取得你的財務健康分數",
    "Your answers are safe — nothing's lost.": "你的回答已安全保存 — 不會遺失。",
    "Your answers are saved, so this is just one more tap.": "你的回答已儲存，只需再輕觸一次。",
    "Your cushion if a shock hits": "市場衝擊時的緩衝",
    "Your Financial fitness score": "你的財務健康分數",
    "Your line": "你這一行",
    "your money": "你的資金",
    "Your money": "你的錢",
    "Your money building": "你的財富累積",
    "Your monthly cash flow": "你的每月現金流",
    "Your Plan": "你的計畫",
    "Your role": "你的職位",
    "Your starting number — and a goal to lift it.": "你的起始數字，以及提升它的目標。"
  }
};

export default translations;
